/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.6.0-nightly.2026.8.30",
    versionName: "0.6.0-nightly.2026.8.30",
    versionChannel: "nightly",
    buildDate: "2026-08-30T00:17:33.461Z",
    commitHash: "77d0f870e3893ed0792d94d88db0cdf9d9ccdec2",
};
